import ParticipantsCommunities from "./ParticipantsCommunities";

export default ParticipantsCommunities;
